import { connect } from 'react-redux';
import CitedBy from './citedBy';

function mapStateToProps(state) {
  const {
    citingArticles: {
      data: {
        hitCount,
        viewMoreUrl,
      },
    },
  } = state;

  return {
    viewMoreUrl: hitCount > 0 && viewMoreUrl
      ? viewMoreUrl
      : null,
  };
}

export default connect(mapStateToProps)(CitedBy);
